import React, {} from 'react';

import nodeControls from '../../node-menu/control-types';
import BaseElement from '../base';

import { determineBaseProperties } from '../utilities';

function PageAuthor(props) {

  const baseElementProperties = determineBaseProperties({
    ...props,
    customNodeControls: [
      nodeControls.ALIGNMENT
    ]
  }, nodeControls);

  function tryRenderAuthor() {

    return <div className="page-author">
      <div className="page-author-details">
        <div className="page-author-picture">
          <img src={props.element.properties.author.profilePicture.url} />
        </div>
        <div className="page-author-details">
          <h5 className="page-author-name">{props.element.properties.author.fullName}</h5>
        </div>
      </div>
    </div>;

  }

  function renderMain() {

    const attributes = {
      ...props.attributes,
      className: '',
      contentEditable: false
    };

    return <div {...attributes}>
      {tryRenderAuthor()}
      {props.children}
    </div>;

  }

  return <BaseElement {...baseElementProperties}>
    {renderMain()}
  </BaseElement>;

}

export default PageAuthor;